module.exports = __webpack_public_path__ + "img/53.9b529cb6.png";